import { html } from "lit";
var icon_apple_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M22.669 17.353a5.415 5.415 0 012.18-4.348.562.562 0 00.078-.809 5.797 5.797 0 00-4.033-1.91c-1.899-.18-3.708 1.124-4.674 1.124-.966 0-2.539-1.124-4.112-1.124a6 6 0 00-5.066 3.101c-2.157 3.753-.55 9.257 1.494 12.336 1.022 1.483 2.247 3.157 3.864 3.1 1.618-.056 2.135-1 4.011-1 1.876 0 2.404 1 4.045.967 1.64-.034 2.775-1.517 3.808-3a13.74 13.74 0 001.54-3 .562.562 0 00-.26-.685 5.348 5.348 0 01-2.875-4.752zM19.77 7.107a5.887 5.887 0 001.371-3.471.562.562 0 00-.674-.573 6.01 6.01 0 00-3.157 1.876 5.696 5.696 0 00-1.404 3.37.562.562 0 00.618.573 5.033 5.033 0 003.246-1.775z" />
  </svg>
`;
export {
  icon_apple_default as default
};
//# sourceMappingURL=icon-apple.js.map
